/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A cash itinerary paired with its award price.
 * @export
 * @interface FlightPointsMatchedOffer
 */
export interface FlightPointsMatchedOffer {
    /**
     * 
     * @type {string}
     * @memberof FlightPointsMatchedOffer
     */
    flightNumber?: string;
    /**
     * 
     * @type {number}
     * @memberof FlightPointsMatchedOffer
     */
    cashCost?: number;
    /**
     * 
     * @type {string}
     * @memberof FlightPointsMatchedOffer
     */
    cashCurrency?: string;
    /**
     * 
     * @type {number}
     * @memberof FlightPointsMatchedOffer
     */
    pointsCost?: number;
    /**
     * Taxes and fees still payable in cash when redeeming.
     * @type {number}
     * @memberof FlightPointsMatchedOffer
     */
    pointsCashCost?: number;
    /**
     * 
     * @type {string}
     * @memberof FlightPointsMatchedOffer
     */
    pointsCurrencyCode?: string;
    /**
     * Value of the redemption against the cash fare, net of the award's own co-pay.
     * @type {number}
     * @memberof FlightPointsMatchedOffer
     */
    centsPerPoint?: number;
    /**
     * 
     * @type {Date}
     * @memberof FlightPointsMatchedOffer
     */
    departsAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof FlightPointsMatchedOffer
     */
    arrivesAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof FlightPointsMatchedOffer
     */
    airline?: string;
    /**
     * 
     * @type {string}
     * @memberof FlightPointsMatchedOffer
     */
    cabinClass?: string;
}

/**
 * Check if a given object implements the FlightPointsMatchedOffer interface.
 */
export function instanceOfFlightPointsMatchedOffer(value: object): value is FlightPointsMatchedOffer {
    return true;
}

export function FlightPointsMatchedOfferFromJSON(json: any): FlightPointsMatchedOffer {
    return FlightPointsMatchedOfferFromJSONTyped(json, false);
}

export function FlightPointsMatchedOfferFromJSONTyped(json: any, ignoreDiscriminator: boolean): FlightPointsMatchedOffer {
    if (json == null) {
        return json;
    }
    return {
        
        'flightNumber': json['flight_number'] == null ? undefined : json['flight_number'],
        'cashCost': json['cash_cost'] == null ? undefined : json['cash_cost'],
        'cashCurrency': json['cash_currency'] == null ? undefined : json['cash_currency'],
        'pointsCost': json['points_cost'] == null ? undefined : json['points_cost'],
        'pointsCashCost': json['points_cash_cost'] == null ? undefined : json['points_cash_cost'],
        'pointsCurrencyCode': json['points_currency_code'] == null ? undefined : json['points_currency_code'],
        'centsPerPoint': json['cents_per_point'] == null ? undefined : json['cents_per_point'],
        'departsAt': json['departs_at'] == null ? undefined : (new Date(json['departs_at'])),
        'arrivesAt': json['arrives_at'] == null ? undefined : (new Date(json['arrives_at'])),
        'airline': json['airline'] == null ? undefined : json['airline'],
        'cabinClass': json['cabin_class'] == null ? undefined : json['cabin_class'],
    };
}

export function FlightPointsMatchedOfferToJSON(json: any): FlightPointsMatchedOffer {
    return FlightPointsMatchedOfferToJSONTyped(json, false);
}

export function FlightPointsMatchedOfferToJSONTyped(value?: FlightPointsMatchedOffer | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'flight_number': value['flightNumber'],
        'cash_cost': value['cashCost'],
        'cash_currency': value['cashCurrency'],
        'points_cost': value['pointsCost'],
        'points_cash_cost': value['pointsCashCost'],
        'points_currency_code': value['pointsCurrencyCode'],
        'cents_per_point': value['centsPerPoint'],
        'departs_at': value['departsAt'] == null ? value['departsAt'] : value['departsAt'].toISOString(),
        'arrives_at': value['arrivesAt'] == null ? value['arrivesAt'] : value['arrivesAt'].toISOString(),
        'airline': value['airline'],
        'cabin_class': value['cabinClass'],
    };
}

